import { ReactNode } from "react";

type SEOSubHeroProps = {
  title: string;
  children: ReactNode;
  className?: string;
};

const SEOSubHero = ({ title, children, className }: SEOSubHeroProps) => {
  return (
    <section className={`py-10 bg-background ${className ?? ""}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold mb-5 text-foreground">
            {title}
          </h2>
          <div className="space-y-4 text-lg leading-relaxed text-muted-foreground [&a]:underline [&a]:underline-offset-4 [&a]:decoration-2 [&a]:text-secondary [&a:hover]:text-primary [&a]:focus-visible:outline-none [&a]:focus-visible:ring-2 [&a]:focus-visible:ring-ring">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SEOSubHero;
